import v2 from '@/stores/helpers/data-explorer-migration-v2.helper';
import v3 from '@/stores/helpers/data-explorer-migration-v3.helper';

const MIGRATION_FUNCTIONS = [v2, v3];

/**
 * Execute the given functions left to right, starting with x as input and using
 * each result as the input to the next function.
 */
const pipe = (...fns) => (x) => fns.reduce((v, fn) => fn(v), x);

/**
 * Send the given report object through every migration function sequentially.
 */
export default pipe(...MIGRATION_FUNCTIONS);

/**
 * The DX schema indicates which DX schema version is currently in use.
 * This must be updated whenever we make breaking DX schema changes.
 */
export const DX_SCHEMA_VERSION = 3;
